import React from 'react';
import { ArrowLeft, ExternalLink, Home, Leaf, Percent, PiggyBank, Building, MapPin, FileText, Heart, Shield, HelpCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

const GuideRenovation = () => {
  const aides = [
    {
      id: 1,
      title: "MaPrimeRénov' (ANAH)",
      icon: Home,
      description: "Aide principale de l'État pour la rénovation énergétique : par geste, parcours accompagné, bailleurs, copropriétés.",
      links: [
        { label: "Site officiel MaPrimeRénov'", url: "https://www.maprimerenov.gouv.fr" },
        { label: "Fiche Service-Public", url: "https://www.service-public.fr/particuliers/vosdroits/F35083" },
        { label: "Portail France Rénov'", url: "https://france-renov.gouv.fr" }
      ]
    },
    {
      id: 2,
      title: "Certificats d'Économies d'Énergie (CEE)",
      icon: Leaf,
      description: "Primes énergie pour isolation, chauffage, ventilation.",
      links: [
        { label: "France Rénov' - CEE", url: "https://france-renov.gouv.fr/aides/cee" },
        { label: "Simulateur aides", url: "https://france-renov.gouv.fr/aides" }
      ]
    },
    {
      id: 3,
      title: "TVA à 5,5 %",
      icon: Percent,
      description: "Taux réduit pour les travaux de rénovation énergétique.",
      links: [
        { label: "Impots.gouv.fr", url: "https://www.impots.gouv.fr/professionnel/questions/quel-taux-de-tva-appliquer-pour-les-travaux-realises-dans-les-logements" }
      ]
    },
    {
      id: 4,
      title: "Éco-Prêt à Taux Zéro (Éco-PTZ)",
      icon: PiggyBank,
      description: "Jusqu'à 50 000 € sans intérêts pour financer vos travaux.",
      links: [
        { label: "Service-Public.fr", url: "https://www.service-public.fr/particuliers/vosdroits/F19905" },
        { label: "Simulateur aides", url: "https://france-renov.gouv.fr/aides" }
      ]
    },
    {
      id: 5,
      title: "Prêt Avance Rénovation (PAR / PAR+)",
      icon: PiggyBank,
      description: "Prêt remboursé à la vente du bien ou à la succession.",
      links: [
        { label: "Simulateur France Rénov'", url: "https://france-renov.gouv.fr/aides" }
      ]
    },
    {
      id: 6,
      title: "Exonération de taxe foncière",
      icon: Building,
      description: "Selon les communes, exonération possible après travaux énergétiques.",
      links: [
        { label: "France Rénov'", url: "https://mesaides.france-renov.gouv.fr/aides/exoneration-fiscale/taxe-fonciere" }
      ]
    },
    {
      id: 7,
      title: "Dispositif Denormandie (bailleurs)",
      icon: Building,
      description: "Réduction d'impôt pour achat + rénovation dans l'ancien.",
      links: [
        { label: "Fiche Service-Public", url: "https://www.service-public.fr/particuliers/vosdroits/F35006" }
      ]
    },
    {
      id: 8,
      title: "Loc'Avantages (bailleurs)",
      icon: Building,
      description: "Réduction fiscale + possibilité de financer des travaux.",
      links: [
        { label: "France Rénov'", url: "https://france-renov.gouv.fr/aides/loc-avantages" },
        { label: "Site ANAH", url: "https://www.anah.gouv.fr" }
      ]
    },
    {
      id: 9,
      title: "MaPrimeAdapt'",
      icon: Heart,
      description: "Aide pour l'adaptation du logement (personnes âgées ou en situation de handicap).",
      links: [
        { label: "France Rénov'", url: "https://france-renov.gouv.fr/aides/maprimeadapt" }
      ]
    },
    {
      id: 10,
      title: "Ma Prime Logement Décent",
      icon: Shield,
      description: "Pour les travaux lourds : sécurité, salubrité du logement.",
      links: [
        { label: "France Rénov'", url: "https://france-renov.gouv.fr/aides/ma-prime-logement-decent" }
      ]
    },
    {
      id: 11,
      title: "Aides locales",
      icon: MapPin,
      description: "Aides complémentaires des communes, départements et régions.",
      links: [
        { label: "Simulateur France Rénov'", url: "https://france-renov.gouv.fr/aides" }
      ]
    },
    {
      id: 12,
      title: "Aides du Département et de l'Agglomération",
      icon: MapPin,
      description: "En plus des aides nationales, certaines collectivités (départements, agglomérations, métropoles, communes) proposent des aides complémentaires pour la rénovation énergétique. Ces dispositifs évoluent régulièrement, souvent tous les 6 mois, et peuvent être cumulés avec les aides de l'État.",
      isSpecial: true,
      specialContent: [
        "Les aides locales disponibles selon l'adresse",
        "Les conditions de cumul",
        "Les montants mobilisables",
        "Les démarches à effectuer"
      ],
      links: []
    },
    {
      id: 13,
      title: "Guide complet ANAH 2026",
      icon: FileText,
      description: "Document officiel récapitulatif de toutes les aides disponibles.",
      links: [
        { label: "Site ANAH", url: "https://www.anah.gouv.fr" },
        { label: "Toutes les aides France Rénov'", url: "https://france-renov.gouv.fr/aides" }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-black pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-[#C9A55C] hover:text-[#C9A55C]/80 mb-8"
        >
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>

        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-sm font-semibold tracking-[0.3em] uppercase text-[#C9A55C]">
            Guide 2026
          </span>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white mt-4 leading-tight">
            Aides à la Rénovation
          </h1>
          <p className="text-xl text-[#C9A55C] mt-4">
            Dispositifs officiels. Informations claires et actualisées.
          </p>
        </div>

        {/* Aides Grid */}
        <div className="space-y-6">
          {aides.map((aide) => (
            <div 
              key={aide.id}
              className={`border p-6 transition-all duration-300 ${
                aide.isSpecial 
                  ? 'border-2 border-[#C9A55C] bg-gradient-to-r from-[#C9A55C]/10 to-transparent' 
                  : 'border-[#C9A55C]/20 hover:border-[#C9A55C]/50'
              }`}
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 border border-[#C9A55C]/30 flex items-center justify-center flex-shrink-0 bg-[#C9A55C]/10">
                  <aide.icon className="w-6 h-6 text-[#C9A55C]" />
                </div>
                <div className="flex-grow">
                  <h2 className="text-xl font-serif font-bold text-white mb-2">
                    {aide.id}. {aide.title}
                  </h2>
                  <p className="text-white/70 mb-4">
                    {aide.description}
                  </p>
                  
                  {aide.isSpecial && aide.specialContent && (
                    <div className="mb-4 p-4 bg-black/30 border-l-4 border-[#C9A55C]">
                      <p className="text-[#C9A55C] font-semibold mb-3">HELP'ADN vérifie systématiquement :</p>
                      <ul className="space-y-2">
                        {aide.specialContent.map((item, i) => (
                          <li key={i} className="flex items-center gap-2 text-white/70">
                            <span className="text-[#C9A55C]">•</span>
                            {item}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                  
                  {aide.links.length > 0 && (
                    <div className="flex flex-wrap gap-3">
                      {aide.links.map((link, index) => (
                        <a
                          key={index}
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="inline-flex items-center gap-2 text-sm text-[#C9A55C] hover:text-[#C9A55C]/80 border border-[#C9A55C]/30 px-3 py-1.5 hover:border-[#C9A55C] transition-all"
                        >
                          {link.label}
                          <ExternalLink className="w-3 h-3" />
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Box - Service HELP ADN */}
        <div className="mt-16 p-8 border-2 border-[#C9A55C] bg-gradient-to-b from-[#C9A55C]/10 to-transparent">
          <div className="text-center mb-8">
            <HelpCircle className="w-12 h-12 text-[#C9A55C] mx-auto mb-4" />
            <h3 className="text-2xl font-serif font-bold text-white mb-4">
              Accompagnement HELP'ADN
            </h3>
          </div>
          
          <div className="max-w-3xl mx-auto mb-8">
            <p className="text-white/70 text-center mb-4">
              HELP'ADN assure la <strong className="text-white">prise en charge complète de vos dossiers</strong> d'aides à la rénovation : MaPrimeRénov', CEE, Éco-PTZ, aides locales.
            </p>
            <p className="text-white/70 text-center mb-6">
              Vérification des conditions. Préparation des pièces. Constitution du dossier. Suivi jusqu'au dépôt.
            </p>
            
            <div className="bg-black/40 border border-[#C9A55C]/30 p-6 text-center">
              <p className="text-[#C9A55C] text-sm uppercase tracking-wider mb-2">Tarif</p>
              <p className="text-3xl font-bold text-white">
                149 € <span className="text-white/50 text-lg">à</span> 299 €
              </p>
              <p className="text-white/50 text-sm mt-2">selon la complexité du dossier</p>
            </div>
          </div>

          <div className="text-center">
            <Link
              to="/#contact"
              className="inline-flex items-center gap-2 bg-[#C9A55C] text-black px-8 py-4 font-semibold tracking-wider uppercase text-sm hover:bg-[#C9A55C]/90 transition-all"
            >
              Demander un devis
              <ArrowLeft className="w-4 h-4 rotate-180" />
            </Link>
          </div>
        </div>

        <p className="text-sm text-white/40 pt-8 text-center">
          Dernière mise à jour : Mars 2026 — Sources officielles gouvernementales
        </p>
      </div>
    </div>
  );
};

export default GuideRenovation;
